<template>
    <DCard
        padding
    >
        <DTable
            class="table-responsive"
            :items="brands"
            :fields="[
                {key: 'id', label: __('settings.brands.index.table.headers.id')},
                {key: 'name', label: __('settings.brands.index.table.headers.name')},
                {key: 'url', label: __('settings.brands.index.table.headers.url')},
                {key: 'mail_general', label: __('settings.brands.index.table.headers.mailGeneral')},
                {key: 'mail_support', label: __('settings.brands.index.table.headers.mailSupport')},
                {key: 'mail_contract', label: __('settings.brands.index.table.headers.mailContract')},
                {key: 'is_default', label: __('settings.brands.index.table.headers.isDefault')},
                {key: 'action', label: ''}
            ]"
        >
            <template #is_default="{item}">
                <td>
                    <DBadge :color="item.is_default ? 'success' : 'danger'">
                        {{ item.is_default ? __('settings.brands.index.table.values.isDefault.yes') : __('settings.brands.index.table.values.isDefault.no') }}
                    </DBadge>
                </td>
            </template>
            <template #action="{item}">
                <td>
                    <div style="display: flex; grid-gap: 10px;">
                        <DButton
                            :id="`edit_${item.id}`"
                            mini
                            icon="pencil"
                            @click="$inertia.get($route('settings.brands.edit', item.id))"
                        />
                        <DButton
                            :id="`make_default_${item.id}`"
                            mini
                            icon="check-circle-outline"
                            :label="__('messages.actions.makeDefault')"
                            :disabled="item.is_default || isInLoadingState"
                            @click="makeDefaultBrand(item)"
                        />
                        <DButton
                            :id="`btn-delete-${item.id}`"
                            mini
                            icon="trash-can-outline"
                            color="danger"
                            :disabled="item.hasCustomers > 0 || isInLoadingState"
                            @click="deleteBrand(item.id)"
                        />
                    </div>
                </td>
            </template>
        </DTable>

        <DFabs>
            <DFab
                id="btn-add"
                icon="plus"
                :label="__('settings.brands.index.addBrandButton')"
                @click="$inertia.get($route('settings.brands.create'))"
            />
        </DFabs>

        <DModal
            v-model:show="showMakeDefaultConfirmationModal"
            :title="__('settings.brands.index.makeDefaultModal.title')"
            :message="__('settings.brands.index.makeDefaultModal.message')"
            is-confirm
            @close="showMakeDefaultConfirmationModal = false"
            @confirm="modalAcceptCallback"
        />
        <DModal
            v-model:show="showDeleteBrandConfirmationModal"
            :title="__('settings.brands.index.deleteBrandModal.title')"
            :message="__('settings.brands.index.deleteBrandModal.message')"
            is-confirm
            is-error
            @close="showDeleteBrandConfirmationModal = false"
            @confirm="modalAcceptCallback"
        />
    </DCard>
</template>

<script>
export default {
    name: 'BrandIndex',
    props: {
        brands: {
            type: Array,
            default () {
                return []
            }
        }
    },
    data: function () {
        return {
            showMakeDefaultConfirmationModal: false,
            showDeleteBrandConfirmationModal: false,
            modalAcceptCallback: () => { return {} }
        }
    },
    methods: {
        makeDefaultBrand (item) {
            this.modalKey = item.id
            this.showMakeDefaultConfirmationModal = true
            this.modalAcceptCallback = () => {
                this.$inertia.post(this.$route('settings.brands.make-default', item.id))
                this.showMakeDefaultConfirmationModal = false
            }
        },
        deleteBrand (brandId) {
            this.showDeleteBrandConfirmationModal = true
            this.modalAcceptCallback = () => {
                this.$inertia.delete(
                    this.$route('settings.brands.destroy', {
                        brand: brandId
                    }))
                this.showDeleteBrandConfirmationModal = false
            }
        }
    }
}
</script>
